// HIDE DEPT — theme.js
// Header scroll state, fullscreen menu, cart drawer, search overlay, add-to-cart (AJAX Cart API).

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- HEADER SCROLL STATE ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('is-solid');
      else header.classList.remove('is-solid');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- FULLSCREEN MENU ---------- */
  var menuOpen = document.querySelector('[data-menu-open]');
  var menuClose = document.querySelector('[data-menu-close]');
  var menuOverlay = document.querySelector('[data-menu-overlay]');
  if (menuOpen && menuOverlay) {
    menuOpen.addEventListener('click', function () {
      menuOverlay.classList.add('is-open');
      menuOverlay.setAttribute('aria-hidden', 'false');
    });
  }
  if (menuClose && menuOverlay) {
    menuClose.addEventListener('click', function () {
      menuOverlay.classList.remove('is-open');
      menuOverlay.setAttribute('aria-hidden', 'true');
    });
  }

  /* ---------- CART DRAWER ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var scrim = document.querySelector('[data-scrim]');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
  }
  cartOpeners.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  cartClosers.forEach(function (el) { el.addEventListener('click', closeCart); });

  /* ---------- SEARCH OVERLAY ---------- */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchOpeners = document.querySelectorAll('[data-search-open]');
  var searchClosers = document.querySelectorAll('[data-search-close]');
  var searchInput = document.querySelector('[data-search-input]');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    if (searchInput) searchInput.focus();
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
  }
  searchOpeners.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); });
  searchClosers.forEach(function (el) { el.addEventListener('click', closeSearch); });

  if (scrim) {
    scrim.addEventListener('click', function () {
      closeCart();
      closeSearch();
    });
  }

  /* ---------- PREDICTIVE SEARCH (Shopify Search API) ---------- */
  if (searchInput) {
    var resultsBox = document.querySelector('[data-search-results]');
    var debounceTimer;
    searchInput.addEventListener('input', function (e) {
      var q = e.target.value.trim();
      clearTimeout(debounceTimer);
      if (!q) {
        if (resultsBox) resultsBox.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (!resultsBox) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              resultsBox.innerHTML = '<p class="search-empty">No results for "' + q + '".</p>';
              return;
            }
            resultsBox.innerHTML = '<div class="product-grid">' + products.map(function (p) {
              return '<a class="product-card" href="' + p.url + '">' +
                '<div class="card-img"><img src="' + p.image + '" alt="' + p.title + '" loading="lazy"></div>' +
                '<div class="card-meta"><span class="card-name">' + p.title + '</span><span class="card-price">' + p.price + '</span></div>' +
                '</a>';
            }).join('') + '</div>';
          })
          .catch(function () { /* fail silently, keep UI calm */ });
      }, 250);
    });
  }

  /* ---------- ADD TO CART (AJAX) ---------- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartDrawer();
          openCart();
        })
        .catch(function (err) { console.error('Add to cart failed', err); });
    });
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartDrawer() {
    if (!cartDrawer) return;
    fetch('/cart?view=drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh) cartDrawer.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* keep existing drawer content on failure */ });
  }

  /* ---------- CART QUANTITY / LINE ITEM UPDATES (event delegation) ---------- */
  document.addEventListener('click', function (e) {
    var incr = e.target.closest('[data-qty-increase]');
    var decr = e.target.closest('[data-qty-decrease]');
    var remove = e.target.closest('[data-line-remove]');
    if (incr || decr) {
      var input = (incr || decr).parentElement.querySelector('input[name="quantity"]');
      var key = (incr || decr).closest('[data-line-item]').getAttribute('data-line-item');
      var qty = parseInt(input.value, 10) + (incr ? 1 : -1);
      qty = Math.max(0, qty);
      updateLine(key, qty, input);
    }
    if (remove) {
      var lineKey = remove.closest('[data-line-item]').getAttribute('data-line-item');
      updateLine(lineKey, 0);
    }
  });

  function updateLine(key, qty, input) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (input) input.value = qty;
        updateCartCount(cart.item_count);
        refreshCartDrawer();
      })
      .catch(function (err) { console.error('Cart update failed', err); });
  }
});
